<template lang="html">
  <a
    v-click-track="{
      action_type: 'visit',
      target: job.full_path,
      top_job: topJob,
      search_score: job._score
    }"
    v-tracking-context="{ event_element: 'job_teaser', id: job.id }"
    :href="job.full_path"
    :class="[selected ? 'fsd-job-teaser--selected' : '', styles.card]"
    @click="onJobClick"
  >
    <div>
      <mark v-if="job.topJob" :class="styles.topJobFlag"> Top Job </mark>
      <span
        v-if="theme == 'search'"
        v-click-track="{
          action_type: `bookmark_toggle_${bookmarked ? 'off' : 'on'}`
        }"
        class="fsd-job-teaser__bookmark"
        :class="{ 'fsd-job-teaser__bookmark--on': bookmarked }"
        @click.stop.prevent="onBookmarkToggleClick"
      >
        <svg-icon
          icon-name="bookmark"
          class-name="fsd-job-teaser__bookmark-flag"
        />
      </span>
      <div v-if="theme == 'widget'" class="bookmark-flag">
        <label
          class="bookmark-flag__toggle-label"
          @click.stop.prevent="onBookmarkToggleClick"
        >
          <span>
            {{ 'bookmarks.bookmark' | t }}
          </span>
        </label>
        <label
          class="bookmark-flag__toggle-label bookmark-flag__toggle-label--bookmarked"
          :class="{ 'bookmark-flag__toggle-label--active': bookmarked }"
          @click.stop.prevent="onBookmarkToggleClick"
        >
          <span>
            {{ 'bookmarks.bookmarked' | t }}
          </span>
        </label>
      </div>
      <h4 :class="styles.title">{{ job.title }}</h4>
    </div>
    <div :class="styles.meta">
      <span v-if="theme == 'search'" class="fsd-job-teaser__meta-content">
        <time :datetime="job.dateBeginUtc" class="fsd-job-teaser__date">
          {{ job.dateBegin }}
        </time>

        <span class="fsd-job-teaser__employer">
          {{ job.employer }}
        </span>

        <span class="fsd-job-teaser__location">
          {{ job.employerLocation }}
        </span>
      </span>
      <div v-if="theme == 'widget'" class="media__body">
        <time :datetime="job.dateBeginUtc" class="post__item-published">
          {{ job.dateBegin }}
        </time>
        <span class="post__item-org">
          <span>{{ job.employer }}</span>
        </span>
        <span class="post__item-location">
          <span>{{ job.employerLocation }}</span>
        </span>
      </div>
      <img
        v-if="job.logo"
        :src="job.logo"
        :class="styles.logo"
        :alt="logoAltText"
      />
    </div>
  </a>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import _debounce from 'lodash-es/debounce'

const LAYOUTS = {
  overview: 'overview',
  widget: 'widget'
}

const WIDGET_STYLES = {
  card: 'post__item card',
  topJobFlag: 'top-job-flag',
  title: 'post__item-title',
  meta: 'post__item-meta media',
  logo: 'post__item-logo media__figure',
  bookmark: ''
}

const SEARCH_STYLES = {
  card: 'fsd-job-teaser',
  topJobFlag: 'fsd-job-teaser__top-job',
  title: 'fsd-job-teaser__title',
  meta: 'fsd-job-teaser__meta',
  logo: 'fsd-job-teaser__logo'
}

export default {
  props: {
    job: { type: Object, required: true },
    bookmarked: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    layout: { type: String, default: LAYOUTS.overview },
    theme: { type: String, default: 'search' }
  },
  computed: {
    ...mapGetters(['isUserFullyLoggedIn', 'isUserKnown']),
    logoAltText() {
      return `${this.job.title} - ${this.job.employer} - Logo`
    },
    topJob() {
      return this.job.topJob ? 1 : 0
    },
    styles() {
      return this.theme === 'widget' ? WIDGET_STYLES : SEARCH_STYLES
    }
  },
  methods: {
    ...mapMutations(['modalOpen']),
    onBookmarkToggleClick: _debounce(
      function () {
        if (!this.job) {
          return
        }
        if (this.isUserFullyLoggedIn) {
          this.$emit('bookmark-toggle')
        } else {
          EventBus.trigger('sessionModal:open', {
            intent: 'toggleBookmark',
            intentData: this.job.id
          })
        }
      },
      300,
      {
        leading: true,
        trailing: false
      }
    ),
    onJobClick(event) {
      if (this.$listeners.select) {
        event.preventDefault()
        this.$emit('select')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~eros/scss/vars';
@import '~eros/scss/utils';
@import '~eros/scss/grid';

.card {
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
</style>
